import React from 'react';
import { Sparkles, Target } from 'lucide-react';
import { aboutContent } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="about" className="relative bg-black py-32 overflow-hidden">
      {/* Subtle gradient accent */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
      
      <div className="max-w-[1400px] mx-auto px-5 md:px-[7.6923%]">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          {/* Left - Visual Element */}
          <div className="relative">
            <div className="relative aspect-square max-w-[500px] mx-auto">
              {/* Animated circles */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-[90%] h-[90%] border border-white/5 rounded-full animate-spin-slow" />
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-[70%] h-[70%] border border-[#00FFD1]/10 rounded-full animate-spin-reverse" />
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-[50%] h-[50%] border border-white/10 rounded-full" />
              </div>
              
              {/* Center content */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <span className="text-[80px] md:text-[100px] font-bold text-white">2026</span>
                  <p className="text-white/50 text-lg">Founded</p>
                </div>
              </div>
              
              {/* Floating nodes */}
              <div className="absolute top-[10%] left-[20%] w-3 h-3 bg-[#00FFD1] rounded-full animate-pulse" />
              <div className="absolute top-[30%] right-[10%] w-2 h-2 bg-white/50 rounded-full animate-pulse delay-300" />
              <div className="absolute bottom-[20%] left-[10%] w-2 h-2 bg-[#6B5BFF]/50 rounded-full animate-pulse delay-500" />
            </div>
          </div>

          {/* Right - Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <span className="text-[#00FFD1] text-lg font-medium tracking-wide">Our Story</span>
              <h2 className="text-4xl md:text-5xl font-semibold text-white leading-tight">
                {aboutContent.title}
              </h2>
            </div>

            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-[#00FFD1]/10 flex items-center justify-center">
                  <Sparkles className="w-6 h-6 text-[#00FFD1]" />
                </div>
                <p className="text-lg text-white/80 leading-relaxed">
                  {aboutContent.description}
                </p>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-[#00FFD1]/10 flex items-center justify-center">
                  <Target className="w-6 h-6 text-[#00FFD1]" />
                </div>
                <p className="text-lg text-white/80 leading-relaxed">
                  {aboutContent.mission}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
